import { createAsyncThunk } from '@reduxjs/toolkit';
import { ref, get } from 'firebase/database';
import { database } from '../../config';

export const fetchEducator = createAsyncThunk(
  'userData/fetchEducator',
  async (educatorId, { rejectWithValue }) => {
    const educatorRef = ref(database, `public_educators/${educatorId}`);
    try {
      const snapshot = await get(educatorRef);
      if (snapshot.exists()) {
        return snapshot.val();
      } else {
        return rejectWithValue('Educator not found');
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchEducatorByUrl = createAsyncThunk(
  'userData/fetchEducatorByUrl',
  async (arg, { rejectWithValue }) => {
    try {
      const url = typeof arg === 'string' ? arg : arg?.url;

      if (!url) {
        return rejectWithValue('No URL provided');
      }

      const snapshot = await get(ref(database, 'public_educators'));
      if (!snapshot.exists()) return rejectWithValue('Educator not found');

      const data = snapshot.val();
      
      // Find educator where educator.url matches
      const normalizedUrl = url.trim().toLowerCase()
      const match = Object.entries(data).find(
        ([, educator]) => educator?.educator?.url?.trim()?.toLowerCase() === normalizedUrl
      );

      if (!match) return rejectWithValue('Educator not found');

      const [educatorId, educatorData] = match;
      return { id: educatorId, ...educatorData };

    } catch (error) {
      return rejectWithValue(error.message || 'Unknown error');
    }
  }
)
